<template>
  <div>
    <icon-view
      gradient
      class="mr-2 mt-5 mb-4 rounded-circle icon-view-color-text"
      icon="fas fa-cloud-upload-alt color-orange mb-1"
      title="Sección de Archivos"
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
    />
    <div v-for="(document, key) in model" :key="key">
      <custom-callout
        v-if="document.visible() !== false"
        :has-border="false"
        :has-toggle="false"
        class-main="mt-3 rounded pt-4 px-5"
      >
        <div
          v-if="isDoc(document.file)"
          class="d-flex align-items-center w-100 justify-content-start"
        >
          <div class="font-weight-normal">
            <label class="circle-green"></label>
            <label class="mb-0">{{ document.file.name }}</label>
          </div>
          <div class="d-flex flex-row-reverse ml-2 button-container">
            <button
              type="button"
              class="btn outline-danger"
              @click="document.file = null"
              :disabled="readOnly"
              :class
            >
              <i class="fas fa-times-circle"></i>
            </button>
            <button
              type="button"
              class="btn outline-success mr-2 ml-2"
              @click="downloadFile(document.file.id)"
            >
              <i class="fas fa-file-download"></i>
            </button>
          </div>
        </div>
        <validation-provider
          v-else
          v-slot="{ errors }"
          :rules="{
            required: document.required === true,
            maxDimensions: [
              getValue(document?.width),
              getValue(document?.height),
            ],
          }"
        >
          <custom-file-input
            display-style="normal"
            label-position="left"
            class="w-50 mx-auto"
            :id="`file-input-${key}`"
            :ref="`file-input-${key}`"
            :addText="getValue(document.title)"
            :accept="getValue(document.accept) ?? '.png,.jpg,.jpeg'"
            :error="errors[0]"
            :custom-error-msg="
              getValue(document.errorMessage) ?? 'La imagen es requerida.'
            "
            :on-download="downloadFile"
            :disabled="readOnly"
            v-model="document.file"
          />
        </validation-provider>
        <p class="text-center mt-1">
          {{ getValue(document.subtitle) }}
        </p>
      </custom-callout>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import IconView from 'icon-view';
import CustomCallout from 'custom-callout';
import CustomFileInput from 'CustomFileInput';
import ActionButton from 'ActionButton';

import generalService from '@/services/pei/general';
import { extend } from 'vee-validate';

extend('maxDimensions', {
  async validate(value, [width, height]) {
    // Verificar si el archivo es una imagen
    const fileType = value.type.split('/')[0];
    if (fileType !== 'image' || !width || !height) return true; // Si no es imagen o no se pasaron las dimensiones, no validamos.

    const dataUrl = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(value);
    });

    if (!dataUrl) return false;

    const img = new Image();
    img.src = dataUrl;

    const isValid = await new Promise((resolve) => {
      img.onload = () => resolve(img.width <= width && img.height <= height);
      img.onerror = () => resolve(false); // En caso de error (no es una imagen válida)
    });

    return isValid;
  },
});

export default {
  name: 'DocumentsSection',
  components: {
    IconView,
    CustomCallout,
    CustomFileInput,
    ActionButton,
    ValidationProvider,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    isDoc() {
      return (val) => val instanceof Object && val?.id;
    },
  },
  methods: {
    downloadFile(id) {
      if (id) generalService.downloadDocumentByAttachmentId(id);
    },
    async onReplace(key) {
      this.$refs[`file-input-${key}`].click();
    },
    async onUploadHandler(key) {
      const files = this.$refs[`file-input-${key}`].files;
      if (files.length > 0) {
        this.model[key].file = files[0];
      }
    },
    getValue(value) {
      return typeof value === 'function' ? value() : value;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .justify-content-start {
  justify-content: center !important;
  margin-bottom: 1rem;
}

.btn-action-size {
  width: 35px;
  height: 35px;
}

::v-deep .btn-action-size > i {
  padding-left: 0px !important;
  vertical-align: text-top !important;
}

.file-select {
  text-align: center;
  margin-bottom: 0px !important;
}
button {
  color: #3f5b60;
  background-color: #ffffff;
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  font-size: 1rem;
  text-align: center;
  border-radius: 4px;
  height: 2.375rem;
  border: 1px solid #3f5b60;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  cursor: pointer;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
  white-space: nowrap;
}

input[type='file'] {
  display: none;
}

.success {
  color: #ffffff;
  background-color: #2db782;
  border-color: #2db782;
}

.outline-success {
  color: #2db782;
  background-color: #ffffff;
  border-color: #2db782;
}

.danger {
  color: #ffffff;
  background-color: #c9545e;
  border-color: #c9545e;
}

.outline-danger {
  color: #c9545e;
  background-color: #ffffff;
  border-color: #c9545e;
}
.outline-danger:hover {
  background-color: #c9545e;
  color: #ffffff;
}
.outline-success:hover {
  background-color: #2db782;
  color: #ffffff;
}

.input-disabled {
  background-color: #e9ecef;
  cursor: initial;
}

.button-container button {
  height: 33px;
  width: 33px;
  padding: 0;
}

.file-input-container {
  height: auto !important;
}
</style>
